export default __webpack_public_path__ + "static/media/clouds-left-desktop.d85f8d68.png";